import React, { useRef, useContext } from 'react';
import { useDay } from '@datepicker-react/hooks';
import DatepickerContext from './context.js';
import { DayContainerStyle, DayButtonStyle } from './styles.js';

function Day({ dayLabel, date }) {
    const hasLabel = !!dayLabel;
    const dayRef = useRef(null);
    const { focusedDate, isDateFocused, isDateSelected, isDateHovered, isDateBlocked, isFirstOrLastSelectedDate, onDateSelect, onDateFocus, onDateHover, } = useContext(DatepickerContext);
    const { isSelected, isSelectedStartOrEnd, isWithinHoverRange, disabledDate, onClick, onKeyDown, onMouseEnter, tabIndex, } = useDay({
        date,
        focusedDate,
        isDateFocused,
        isDateSelected,
        isDateHovered,
        isDateBlocked,
        isFirstOrLastSelectedDate,
        onDateFocus,
        onDateSelect,
        onDateHover,
        dayRef,
    });
    const shouldHaveHover = !isSelectedStartOrEnd && !isSelected && !isWithinHoverRange;
    const isSelectedOrHoverRange = isSelected || isWithinHoverRange;
    return hasLabel ? (React.createElement(DayContainerStyle, { isSelectedStartOrEnd: isSelectedStartOrEnd, isSelectedOrHoverRange: isSelectedOrHoverRange, disabled: disabledDate, className: isSelectedStartOrEnd ? 'selected' : '' },
        React.createElement(DayButtonStyle, { isSelectedStartOrEnd: isSelectedStartOrEnd, isSelectedOrHoverRange: isSelectedOrHoverRange, disabled: disabledDate, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, ref: dayRef, shouldHaveHover: shouldHaveHover, tabIndex: tabIndex, type: "button" }, dayLabel))) : null;
}

export { Day as default };
